import ComponentModule from "@eisinc/Overrides/Components/FindLocationModal";

export * from "@eisinc/Overrides/Components/FindLocationModal";

export default ComponentModule;
